<template>
    <validation-observer ref="refForm">

        <b-form @submit.prevent="onSubmit">

            <b-row>
                <b-col md="12">
                    <b-card footer-tag="footer">

                        <b-row>

                            <!-- STATE + PUBLISHED AT -->
                            <b-col cols="12">
                                <b-alert variant="info" :show="true">
                                    <div class="alert-body d-flex flex-wrap align-items-center">
                                        <span class="mr-1">Estado actual:</span>
                                        <b-badge pill variant="light-primary" class="mr-2">{{ blogData.blog_state_name }}</b-badge>
                                        <span class="mr-1">Fecha de publicación:</span>
                                        <strong>{{ blogData.published_at ? moment(blogData.published_at).format('DD/MM/YYYY HH:mm') : 'Sin publicar' }}</strong>
                                    </div>
                                </b-alert>
                            </b-col>

                            <!-- TITLE -->
                            <b-col cols="12" md="8">
                                <b-form-group label-for="title">
                                    <template #label>
                                        <strong>TÍTULO</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="título"
                                    >
                                        <b-form-input
                                            id="title"
                                            v-model="formData.title"
                                            placeholder="Ingrese el título del blog ..."
                                            maxlength="255"
                                            :state="errors.length > 0 ? false : null"
                                            trim
                                        />
                                        <small class="textarea-counter-value float-right">
                                            <strong class="char-count">{{ formData.title ? formData.title.length : 0 }} / 255</strong>
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <!-- AUTHOR -->
                            <b-col cols="12" md="4">
                                <b-form-group label-for="doctor">
                                    <template #label>
                                        <strong>AUTOR</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="autor"
                                    >
                                        <v-select
                                            id="doctor"
                                            placeholder="Seleccionar un psicólogo"
                                            v-model="formData.doctor"
                                            :options="options.doctors"
                                            :state="errors.length > 0 ? false : null"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <!-- SHORT DESCRIPTION -->
                            <b-col cols="12">
                                <b-form-group label-for="short_description">
                                    <template #label>
                                        <strong>DESCRIPCIÓN CORTA</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="descripción corta"
                                    >
                                        <b-form-textarea
                                            id="short_description"
                                            v-model="formData.short_description"
                                            placeholder="Texto que se verá en la tarjeta del blog en la web ..."
                                            rows="3"
                                            maxlength="300"
                                            :state="errors.length > 0 ? false : null"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                    <small class="textarea-counter-value float-right">
                                        <strong class="char-count">{{ formData.short_description ? formData.short_description.length : 0 }} / 300</strong>
                                    </small>
                                </b-form-group>
                            </b-col>

                            <!-- TAGS -->
                            <b-col cols="12">
                                <b-form-group label-for="tags">
                                    <template #label>
                                        <strong>ETIQUETAS</strong>
                                    </template>
                                    <v-select
                                        id="tags"
                                        v-model="formData.tags"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        multiple
                                        taggable
                                        push-tags
                                        placeholder="Escriba una etiqueta y presione Enter ..."
                                        :options="options.tags"
                                    />
                                    <small class="text-muted">
                                        Puede elegir etiquetas ya usadas o crear nuevas escribiéndolas y presionando Enter.
                                    </small>
                                </b-form-group>
                            </b-col>

                            <!-- IMAGE -->
                            <b-col cols="12">
                                <div id="preview" v-if="formData.imageUrl">
                                    <b-img
                                        fluid
                                        :src="formData.imageUrl"
                                        thumbnail
                                        width="300"
                                        alt="portada"
                                    />
                                </div>

                                <b-form-group label-for="image">
                                    <template #label>
                                        <strong>CAMBIAR IMAGEN DE PORTADA (FORMATO: webp)</strong>
                                    </template>
                                    <b-form-file
                                        id="image"
                                        v-model="formData.image"
                                        @change="onFileChange"
                                        accept=".webp"
                                        ref="image"
                                        placeholder="Elija una imagen ..."
                                        no-drop
                                    />
                                </b-form-group>
                                <small class="text-muted d-block mb-2">Si no elige una imagen nueva, se conserva la actual.</small>
                            </b-col>

                            <!-- CONTENT -->
                            <b-col cols="12">
                                <b-form-group label-for="content">
                                    <template #label>
                                        <strong>CONTENIDO</strong>
                                    </template>
                                    <quill-editor
                                        id="content"
                                        v-model="formData.content"
                                        :options="editorOptions"
                                    />
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <template #footer>

                            <b-button-loading
                                text="ACTUALIZAR"
                                type="submit"
                                :processing="processing">
                            </b-button-loading>

                            <b-button
                                variant="outline-secondary"
                                class="ml-1"
                                :to="{ name: 'blogs' }"
                            >
                                CANCELAR
                            </b-button>

                        </template>

                    </b-card>
                </b-col>
            </b-row>

        </b-form>

    </validation-observer>
</template>

<script>

    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
    import BButtonLoading from '@core/components/b-button-loading/BButtonLoading.vue';
    import { ref, onBeforeMount } from '@vue/composition-api';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { useToast } from 'vue-toastification/composition';
    import { quillEditor } from 'vue-quill-editor';
    import Ripple from 'vue-ripple-directive';
    import { required } from '@validations';
    import vSelect from 'vue-select';
    import router from '@/router';
    import store from '@/store';
    import moment from 'moment';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,

            BButtonLoading,
            quillEditor,

            required,

            vSelect
        },
        directives: {
            Ripple
        },
        props: {
            blogData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                moment
            }
        },
        setup(props) {

            // USE TOAST
            const toast = useToast();

            // REFS
            const processing = ref(false);
            const refForm = ref(null);
            const options = ref({ doctors: [], tags: [] });

            const image = ref(null);

            const formData = ref({
                title: props.blogData.title,
                doctor: null,
                short_description: props.blogData.short_description,
                tags: props.blogData.tags || [],
                imageUrl: props.blogData.imageUrl,
                image: null,
                content: props.blogData.content
            });

            const editorOptions = {
                theme: 'snow',
                placeholder: 'Escriba aquí el contenido del blog ...',
                modules: {
                    toolbar: [
                        [{ header: [2, 3, 4, false] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ align: [] }],
                        ['blockquote', 'link', 'image', 'video'],
                        ['clean']
                    ]
                }
            };

            onBeforeMount(() => {
                getSelectFilters();
            });

            const getSelectFilters = async () => {

                const response = await store.dispatch('app-blog/fetchSelectOptions');
                options.value = response.data;

                // El autor llega como id; se busca su opción para que v-select
                // muestre el nombre en lugar del número.
                const selected = options.value.doctors.find(doctor => doctor.value === props.blogData.doctor_id);

                if (selected) formData.value.doctor = selected;

            };

            const onFileChange = (e) => {
                const file = e.target.files[0];

                if (file) {
                    formData.value.image = file;
                    formData.value.imageUrl = URL.createObjectURL(file);
                } else {
                    formData.value.image = null;
                }
            };

            const showToast = (title, icon, variant) => {
                toast({
                    component: ToastificationContent,
                    props: { title, icon, variant }
                });
            };

            const onSubmit = async () => {

                const isValid = await refForm.value.validate();

                if (!isValid)
                {
                    showToast('Complete los campos requeridos.', 'AlertTriangleIcon', 'warning');
                    return;
                }

                processing.value = true;

                const {

                    title,
                    doctor,
                    short_description,
                    tags,
                    image: imageFile,
                    content

                } = formData.value;

                const payload = {
                    title,
                    doctor_id: doctor ? doctor.value : null,
                    short_description,
                    tags: (tags || []).map(tag => (typeof tag === 'string' ? tag : tag.label)),
                    content,
                    image: imageFile
                };

                store.dispatch('app-blog/updateBlog', { id: router.currentRoute.params.id, payload })
                    .then(response => {

                        showToast(response.data.message, 'CheckIcon', 'success');

                        processing.value = false;

                    })
                    .catch(err => {
                        const message = err.response && err.response.data.message ? err.response.data.message : 'Error al actualizar el blog.';

                        showToast(message, 'AlertTriangleIcon', 'danger');

                        processing.value = false;
                    });

            };

            return {
                // DATA
                processing,
                formData,
                editorOptions,

                // REFS
                refForm,
                options,
                image,

                // METHODS
                onFileChange,
                onSubmit
            }
        }
    }

</script>

<style lang="scss" scoped>

    #preview {
        text-align: center;
        margin-bottom: 1rem;
    }

</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/quill.scss';
</style>
